import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { AgreementDto } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    value?: string;
    label?: React.ReactNode;
    required?: boolean;
    error?: boolean;
    helperText?: React.ReactNode;
    onChange: (agreement?: AgreementDto) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Seletor de termos de aceitação de treinamentos
 * @param props
 */
export const TrainingAgreementSelect: React.FC<IProps> = (props) => {

    const api = useCoreApi();
    const { t } = useTranslation();

    const { required, label, value, error, helperText, onChange } = props;

    const [items, setItems] = useState<AgreementDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        api.v1.selectors.trainingAgreements({})
            .then(response => setItems(response.data))
            .catch(e => MprcRequestSnackbarErrorReport(e))
            .finally(() => setLoading(false));
    }, []);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <FormControl fullWidth required={required}>
            <InputLabel id="agreementSelect">{label ?? t("Settings.Agreement.SelectAgreementLabel")}</InputLabel>
            <Select
                label={label}
                labelId="agreementSelect"
                displayEmpty
                value={value}
                onChange={(e) => onChange(items?.find(p => p.agreementId == e.target.value))}
                error={!!error}
                renderValue={(selected) => {
                    return loading
                        ? t("shared:Literal.Loading")
                        : items?.find(p => p.agreementId == selected)?.name;
                }}
            >
                {
                    items.map(item => <MenuItem key={item.agreementId} value={item.agreementId}>{item.name}</MenuItem>)
                }
            </Select>
            {
                (helperText) &&
                <FormHelperText sx={{ ml: 0 }} error={!!error}>{helperText}</FormHelperText>
            }
        </FormControl >

    );
};
